export default class ManagementResponse{
    countArtists;
    countEvents;
}